import { ApiErrorMessageBag, ApiErrorResponse } from "@/stores/errors/ApiErrorMessageBag";
import { FieldValidationError } from "@/stores/errors/FieldValidationError";
import { Model } from "@/stores/AbstractBase.store";
import { FilterParamValue } from "@/stores/filters/FilterParamValue.ts";
import { User } from "@/models/User.model";

export class LessonPlanCollection implements Model {

	static createFromApiData(data: any) {
		const newObject = new LessonPlanCollection();
		newObject.hydrateWithApiData(data);
		return newObject;
	}

	public name: string = "";
	public id?: string;
	public color?: string;
	public _planCount: number = 0;
	public sharing: null | 'account' | 'group' | 'everyone' = null;
	public sharingWithSubjectId: string | null = null;
	public userId: string | null = null;
	public owner: User | null = null;
	public planIds: string[] = [];

	public get planCount(): number {
  		return this._planCount;
	}
	public set planCount(value: number) {
		this._planCount = value;
	}

	hydrateWithApiData(data: any) {
		if (typeof data.id !== 'undefined') {
			this.id = data.id;
		}

		this.name = data.name;

		if (typeof data.color !== 'undefined') {
			this.color = data.color;
		}

		// if (typeof data.planCount !== 'undefined') {
		if (typeof data.planCount === 'number') {
			this._planCount = data.planCount;
		}

		if (typeof data.sharing !== 'undefined') {
			this.sharing = data.sharing;
		}

		if (typeof data.sharingWithSubjectId !== 'undefined') {
			this.sharingWithSubjectId = data.sharingWithSubjectId !== null ? String(data.sharingWithSubjectId) : null;
		}

		if (typeof data.userId !== 'undefined') {
			this.userId = data.userId;
		}

		if (typeof data.owner !== 'undefined' && data.owner !== null) {
			this.owner = User.createFromApiData(data.owner);
		}

		if (Array.isArray(data.plans)) {
			this.planIds = data.plans.map((p: any) => p.id);
		}

		return this;
	}

	isValid(): boolean {
		return this.name !== null && this.name !== "" && this.name.length > 0;
	}

	validate(): void {
		if (!this.isValid()) {
			const error = new ApiErrorMessageBag();
			error.fields["name"] = new FieldValidationError("name", [{
				key: 'validation.required',
				message: 'The name field is required.',
				parameters: {}
			} as ApiErrorResponse]);

			throw error;
		}
	}

	asApiDataObject(): any {
		return {
			name: this.name,
			color: this.color,
			planCount: this._planCount,
			sharing: this.sharing,
			sharingWithSubjectId: this.sharingWithSubjectId,
		};
	}

	asFilterParamValue(): FilterParamValue
	{
		if (!this.id) {
			throw new Error("Cannot create FilterParamValue for LessonPlanCollection without id");
		}

		return new FilterParamValue(this.id, this.name);
	}

	clone(): LessonPlanCollection {
		const cloned = new LessonPlanCollection();

		cloned.name = this.name;
		cloned.color = this.color;
		cloned.sharing = this.sharing;
		cloned.sharingWithSubjectId = this.sharingWithSubjectId;
		cloned.userId = this.userId;
		cloned.planIds = [...this.planIds];

		if (this.owner) {
			cloned.owner = this.owner.clone();
		}

		if (this.id) {
			cloned.id = this.id;
		}
		// if (this.planCount !== undefined) {
			cloned._planCount = this._planCount;
		// }
		return cloned;
	}

	equals(other: Model): boolean {
		if (!(other instanceof LessonPlanCollection)) {
			return false;
		}

		return JSON.stringify(this.asApiDataObject()) === JSON.stringify(other.asApiDataObject());
	}
}
